function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo, useCallback, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Dropdown, DropableContainer, DropdownList, DropdownListContainer, TitleComponent, EmptySearch, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { useSearch } from '@keen.io/react-hooks';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { Container } from './EventCollection.styles';
import { getEventsCollections } from '../../modules/events';

var EventCollection = function EventCollection(_ref) {
  var collection = _ref.collection,
      onChange = _ref.onChange,
      onReset = _ref.onReset,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'secondary' : _ref$variant,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectionIndex = _useState4[0],
      setIndex = _useState4[1];

  var collections = useSelector(getEventsCollections);
  var options = useMemo(function () {
    return collections.map(function (name) {
      return {
        label: name,
        value: name
      };
    });
  }, [collections]);

  var _useState5 = useState(options),
      _useState6 = _slicedToArray(_useState5, 2),
      collectionsList = _useState6[0],
      setCollectionsList = _useState6[1];

  var collectionListRef = useRef(collectionsList);
  var selectionIndexRef = useRef(selectionIndex);
  selectionIndexRef.current = selectionIndex;
  collectionListRef.current = collectionsList;
  var keyboardHandler = useCallback(function (e) {
    var optionsList = collectionListRef.current;

    switch (e.keyCode) {
      case KEYBOARD_KEYS.ENTER:
        if (optionsList && optionsList.length) {
          var value = optionsList[selectionIndexRef.current].value;
          onChange(value);
        }

        setOpen(false);
        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndexRef.current === null) {
          setIndex(0);
        } else if (selectionIndexRef.current > 0) {
          setIndex(selectionIndexRef.current - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndexRef.current === null) {
          setIndex(0);
        } else if (selectionIndexRef.current < optionsList.length - 1) {
          setIndex(selectionIndexRef.current + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setOpen(false);
        break;
    }
  }, [collectionsList]);

  var _useSearch = useSearch(options, function (searchResult, phrase) {
    setIndex(null);

    if (phrase) {
      setCollectionsList(searchResult);
    } else {
      setCollectionsList(options);
    }
  }),
      searchHandler = _useSearch.searchHandler,
      searchPhrase = _useSearch.searchPhrase,
      clearSearchPhrase = _useSearch.clearSearchPhrase;

  useEffect(function () {
    if (isOpen) {
      var index = options.findIndex(function (_ref2) {
        var value = _ref2.value;
        return value === collection;
      });
      setIndex(index);
      document.addEventListener('keydown', keyboardHandler);
    } else {
      setCollectionsList(options);
      clearSearchPhrase();
    }

    return function () {
      document.removeEventListener('keydown', keyboardHandler);
    };
  }, [isOpen]);
  useEffect(function () {
    setCollectionsList(options);
  }, [options]);
  useEffect(function () {
    return function () {
      if (onReset) onReset();
    };
  }, []);
  return React.createElement(Container, null, React.createElement(TitleComponent, {
    "data-testid": "event-collection-title",
    onClick: function onClick() {
      return setOpen(true);
    },
    hasError: hasError
  }, t('query_creator_event_collection.label')), React.createElement(DropableContainer, {
    variant: variant,
    hasError: hasError,
    searchPlaceholder: t('query_creator_event_collection.search_placeholder'),
    placeholder: t('query_creator_event_collection.placeholder'),
    onClick: function onClick() {
      return !isOpen && setOpen(true);
    },
    isActive: isOpen,
    value: collection,
    searchable: true,
    dropIndicator: true,
    onSearch: searchHandler,
    onDefocus: function onDefocus() {
      setOpen(false);
    }
  }, React.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[500],
    enableTextEllipsis: true
  }, collection)), React.createElement(Dropdown, {
    isOpen: isOpen
  }, searchPhrase && !collectionsList.length ? React.createElement(EmptySearch, {
    message: t('query_creator_event_collection.empty_search_results')
  }) : React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 240
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      ref: activeItemRef,
      items: collectionsList,
      setActiveItem: function setActiveItem(_item, idx) {
        return selectionIndex === idx;
      },
      onClick: function onClick(_e, _ref3) {
        var value = _ref3.value;

        if (collection !== value) {
          onChange(value);
        }

        setCollectionsList(options);
      }
    });
  })));
};

export default EventCollection;